// javascript
import * as React from 'react';
import { useCallback, useEffect, useState } from 'react';
import AuthLayout from '../../../../bidder/layouts/AuthLayout';
import BidderPanel from '../../../../bidder/components/Panels/BidderPanel';
import axios from '../../../../services/axios';

export default function List() {
  const [items, setItems] = useState([]);
  const [pending, setPending] = useState(false);
  const [errors, setErrors] = useState({}); // key -> error message
  const [texts, setTexts] = useState({}); // key -> text input buffer

  const load = useCallback(async () => {
    setPending(true);
    setErrors({});
    try {
      const res = await axios.get('/api/dashboard/settings');
      const data = Array.isArray(res.data) ? res.data : [];
      setItems(data);
      // подготовим локальные буферы для текстов
      const nextTexts = {};
      data.forEach((it) => {
        if (it.setting_type === 'text') {
          nextTexts[it.setting_key] = it.value?.value ?? '';
        }
      });
      setTexts(nextTexts);
    } catch (e) {
      console.error(e);
    } finally {
      setPending(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const uploadFile = async (settingKey, file) => {
    setErrors((p) => ({ ...p, [settingKey]: undefined }));
    const form = new FormData();
    form.append('setting_key', settingKey);
    form.append('file', file);
    try {
      await axios.post('/api/dashboard/settings/file', form, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      await load();
    } catch (e) {
      setErrors((p) => ({ ...p, [settingKey]: 'Ошибка загрузки файла' }));
    }
  };

  const saveText = async (settingKey) => {
    setErrors((p) => ({ ...p, [settingKey]: undefined }));
    try {
      await axios.post('/api/dashboard/settings/text', {
        setting_key: settingKey,
        text_value: texts[settingKey] ?? ''
      });
      await load();
    } catch (e) {
      setErrors((p) => ({ ...p, [settingKey]: 'Ошибка сохранения текста' }));
    }
  };

  const saveBoolean = async (settingKey, value) => {
    setErrors((p) => ({ ...p, [settingKey]: undefined }));
    try {
      await axios.post('/api/dashboard/settings/boolean', {
        setting_key: settingKey,
        boolean_value: !!value
      });
      await load();
    } catch (e) {
      setErrors((p) => ({ ...p, [settingKey]: 'Ошибка сохранения флага' }));
    }
  };

  const renderFile = (item) => {
    const meta = item.value?.value || {};
    const filename = meta.filename || '—';
    const showLink = meta.show_link || null;
    const downloadLink = meta.download_link || null;

    return (
      <div style={{ border: '1px solid #e0e0e0', padding: 12, borderRadius: 8, marginBottom: 12 }}>
        <div style={{ fontWeight: 600 }}>{item.setting_title}</div>
        <div style={{ marginTop: 8 }}>
          <div>Uploaded file: {filename}</div>
          <div style={{ display: 'flex', gap: 12, marginTop: 6 }}>
            {showLink ? (
              <a href={showLink} target="_blank" rel="noreferrer">
                view
              </a>
            ) : (
              <span style={{ color: '#888' }}>Cant showing</span>
            )}
            {downloadLink ? (
              <a href={downloadLink} target="_blank" rel="noreferrer">
                download
              </a>
            ) : (
              <span style={{ color: '#888' }}>скачать недоступно</span>
            )}
          </div>
        </div>
        <div style={{ marginTop: 10 }}>
          <label style={{ display: 'inline-block' }}>
            <input
              type="file"
              onChange={(e) => {
                const f = e.target.files?.[0];
                if (f) uploadFile(item.setting_key, f);
                e.target.value = '';
              }}
            />
          </label>
        </div>
        {errors[item.setting_key] && (
          <div style={{ color: '#c00', marginTop: 6 }}>{errors[item.setting_key]}</div>
        )}
      </div>
    );
  };

  const renderText = (item) => {
    const key = item.setting_key;

    return (
      <div style={{ border: '1px solid #e0e0e0', padding: 12, borderRadius: 8, marginBottom: 12 }}>
        <div style={{ fontWeight: 600 }}>{item.setting_title}</div>
        <div style={{ marginTop: 8 }}>
          <input
            type="text"
            value={texts[key] ?? ''}
            onChange={(e) => setTexts((p) => ({ ...p, [key]: e.target.value }))}
            style={{ width: '100%', padding: 8 }}
            placeholder="Input text"
          />
        </div>
        <div style={{ marginTop: 10 }}>
          <button onClick={() => saveText(key)} disabled={pending}>
            Save
          </button>
        </div>
        {errors[key] && <div style={{ color: '#c00', marginTop: 6 }}>{errors[key]}</div>}
      </div>
    );
  };

  const renderBoolean = (item) => {
    const key = item.setting_key;
    const value = !!(item.value?.value ?? false);

    return (
      <div style={{ border: '1px solid #e0e0e0', padding: 12, borderRadius: 8, marginBottom: 12 }}>
        <div style={{ fontWeight: 600 }}>{item.setting_title}</div>
        <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8 }}>
          <input
            type="checkbox"
            checked={value}
            onChange={(e) => saveBoolean(key, e.target.checked)}
          />
          <span>{value ? 'Enabled' : 'Disabled'}</span>
        </label>
        {errors[key] && <div style={{ color: '#c00', marginTop: 6 }}>{errors[key]}</div>}
      </div>
    );
  };

  return (
    <AuthLayout title="Settings(temporary)">
      <BidderPanel>
        {pending && items.length === 0 ? (
          <div>Loading...</div>
        ) : (
          <div>
            {items.map((item) => {
              if (item.setting_type === 'file')
                return <React.Fragment key={item.setting_key}>{renderFile(item)}</React.Fragment>;
              if (item.setting_type === 'text')
                return <React.Fragment key={item.setting_key}>{renderText(item)}</React.Fragment>;
              if (item.setting_type === 'boolean')
                return (
                  <React.Fragment key={item.setting_key}>{renderBoolean(item)}</React.Fragment>
                );

              return (
                <div key={item.setting_key} style={{ marginBottom: 12 }}>
                  <div style={{ fontWeight: 600 }}>{item.setting_title}</div>
                  <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', marginTop: 8 }}>
                    Неподдерживаемый тип: {item.setting_type}
                  </pre>
                </div>
              );
            })}
          </div>
        )}
      </BidderPanel>
    </AuthLayout>
  );
}
